import React from 'react';
import { ArrowRightIcon, PlayIcon, MusicIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSpotify } from './SpotifyContext';
const Biography = () => {
  const {
    openSpotifyPlayer
  } = useSpotify();
  return <div className="pt-28 md:pt-36 space-y-16" data-id="element-61">
      {/* Hero Section */}
      <section className="relative" data-id="element-62">
        <div className="absolute -inset-1 bg-gradient-to-r from-pink-500/20 to-purple-500/20 rounded-2xl blur-lg" data-id="element-63"></div>
        <div className="relative overflow-hidden rounded-2xl" data-id="element-64">
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40 z-10" data-id="element-65"></div>
          <img src="https://fabricreality.com/wp-content/uploads/2022/09/Photo29.jpg" alt="Fabric Reality" className="w-full h-[40vh] sm:h-[50vh] object-cover object-center" data-id="element-66" />
          <div className="absolute inset-0 z-20 flex flex-col justify-center p-6 md:p-12" data-id="element-67">
            <h1 className="text-5xl sm:text-6xl font-bold mb-4 text-white drop-shadow-lg font-mono" data-id="element-68">
              OUR{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400" data-id="element-69">
                STORY
              </span>
            </h1>
            <p className="text-xl sm:text-2xl text-gray-100 max-w-2xl mb-4 drop-shadow-md" data-id="element-70">
              The journey of Fabric Reality
            </p>
          </div>
        </div>
      </section>
      {/* The Beginning */}
      <section className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-71">
        <div className="relative order-2 md:order-1" data-id="element-72">
          <div className="absolute -inset-1 bg-gradient-to-r from-purple-500/30 to-pink-500/30 rounded-xl blur" data-id="element-73"></div>
          <img src="https://fabricreality.com/wp-content/uploads/2022/09/211881920002-scaled-1.jpg" alt="Fabric Reality origins" className="relative rounded-xl w-full aspect-square object-cover" data-id="element-74" />
        </div>
        <div className="order-1 md:order-2" data-id="element-75">
          <h2 className="text-4xl font-bold mb-6 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-76">
            THE BEGINNING
          </h2>
          <div className="space-y-4 text-gray-200" data-id="element-77">
            <p className="text-lg" data-id="element-78">
              Fabric Reality is the music project of Garbs, a
              Singer/Songwriter/Producer of Irish descent and
              Producer/Songwriter/Creator Russell James Williams.
            </p>
            <p className="text-lg" data-id="element-79">
              Friends for ten years after meeting on the touring circuit with
              their respective bands, they began exchanging ideas based on
              initial demos of what Garbs defined as Interstellar Alternative
              Pop.
            </p>
            <p className="text-lg" data-id="element-80">
              The project officially began in late 2020, during a time when the
              world was experiencing unprecedented change. This period of global
              reflection created the perfect environment for Fabric Reality to
              develop their unique sound.
            </p>
          </div>
        </div>
      </section>
      {/* The Sound */}
      <section className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-81">
        <div data-id="element-82">
          <h2 className="text-4xl font-bold mb-6 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-83">
            THE SOUND
          </h2>
          <div className="space-y-4 text-gray-200" data-id="element-84">
            <p className="text-lg" data-id="element-85">
              Within weeks of their first collaboration, Fabric Reality was
              born. Heavily styled synth-based landscapes, infused with guitars,
              wrap around dynamic song structures and infectious melodies.
            </p>
            <p className="text-lg" data-id="element-86">
              Their sound is a spectacular fusion full of ambition to create a
              new moment for the Alternative genre. Drawing inspiration from
              both electronic music and traditional rock, they've created
              something that feels both familiar and completely new.
            </p>
            <p className="text-lg" data-id="element-87">
              The cosmic themes in their music reflect their belief that music
              can transport listeners to different dimensions, creating an
              immersive experience that goes beyond just listening.
            </p>
            <div className="mt-6" data-id="element-88">
              <button onClick={openSpotifyPlayer} className="inline-flex items-center text-pink-400 hover:text-pink-300 transition-colors" data-id="element-89">
                <PlayIcon size={16} className="mr-2" data-id="element-90" />
                <span data-id="element-91">LISTEN TO OUR MUSIC</span>
              </button>
            </div>
          </div>
        </div>
        <div className="relative" data-id="element-92">
          <div className="absolute -inset-1 bg-gradient-to-r from-purple-500/30 to-pink-500/30 rounded-xl blur" data-id="element-93"></div>
          <img src="https://fabricreality.com/wp-content/uploads/2022/09/Photo09_9.jpg" alt="Fabric Reality sound" className="relative rounded-xl w-full aspect-square object-cover" data-id="element-94" />
        </div>
      </section>
      {/* The Vision */}
      <section className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-95">
        <div className="relative order-2 md:order-1" data-id="element-96">
          <div className="absolute -inset-1 bg-gradient-to-r from-purple-500/30 to-pink-500/30 rounded-xl blur" data-id="element-97"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aoNiK6X7s9SwvUUd4f5yBG/1659642876701_filtered.jpg" alt="Fabric Reality vision" className="relative rounded-xl w-full aspect-square object-cover" data-id="element-98" />
        </div>
        <div className="order-1 md:order-2" data-id="element-99">
          <h2 className="text-4xl font-bold mb-6 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-100">
            THE VISION
          </h2>
          <div className="space-y-4 text-gray-200" data-id="element-101">
            <p className="text-lg" data-id="element-102">
              Fabric Reality isn't just about the music—it's about creating a
              complete sensory experience. Their vision extends to visual art,
              performance, and community building.
            </p>
            <p className="text-lg" data-id="element-103">
              The band sees their work as a gateway to an alternate universe
              where listeners can escape, explore, and connect with something
              larger than themselves.
            </p>
            <p className="text-lg" data-id="element-104">
              This vision is reflected in everything from their immersive
              visualizers to their live performances, which aim to transport
              audiences to another dimension through sound and visuals.
            </p>
          </div>
        </div>
      </section>
      {/* Debut EP */}
      <section className="relative" data-id="element-105">
        <div className="absolute -inset-1 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-2xl blur-lg" data-id="element-106"></div>
        <div className="relative bg-black/60 backdrop-blur-md p-8 rounded-2xl border border-purple-500/20 shadow-xl" data-id="element-107">
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-108">
            <div className="md:w-1/3 relative" data-id="element-109">
              <div className="absolute -inset-1 bg-gradient-to-r from-pink-500/30 to-purple-500/30 rounded-xl blur" data-id="element-110"></div>
              <img src="https://fabricreality.com/wp-content/uploads/2022/09/NEW-EXHIBITION-1-e1648686271558.png" alt="Exhibition EP" className="relative rounded-xl w-full aspect-square object-cover" data-id="element-111" />
            </div>
            <div className="md:w-2/3" data-id="element-112">
              <h2 className="text-4xl font-bold mb-4 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-113">
                DEBUT EP: EXHIBITION
              </h2>
              <p className="text-lg text-gray-300 mb-6" data-id="element-114">
                In 2022, Fabric Reality released their debut EP "Exhibition,"
                featuring the singles 'Exhibition', 'How It Feels To Love You
                Lately' and 'Sunset On Saturn.' This collection of tracks
                showcases the band's signature interstellar sound, taking
                listeners on a journey through space while keeping them grounded
                in emotion.
              </p>
              <p className="text-lg text-gray-300 mb-6" data-id="element-115">
                The EP received critical acclaim for its innovative sound
                design, emotional depth, and genre-defying approach. It marked
                the beginning of Fabric Reality's mission to redefine
                alternative music for a new generation.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-116">
                <button onClick={openSpotifyPlayer} className="px-6 py-3 bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-500 hover:to-purple-500 text-white font-bold rounded-lg transition-all duration-300 hover:shadow-lg hover:shadow-pink-500/30 flex items-center" data-id="element-117">
                  <MusicIcon size={18} className="mr-2" data-id="element-118" />
                  LISTEN NOW
                </button>
                <Link to="/lyrics" className="px-6 py-3 bg-black/50 backdrop-blur-sm border border-pink-500/30 hover:bg-black/70 text-white font-bold rounded-lg transition-all duration-300 flex items-center" data-id="element-119">
                  VIEW LYRICS
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Looking Forward */}
      <section className="p-8 bg-gradient-to-r from-pink-900/20 to-purple-900/20 rounded-xl border border-pink-500/10" data-id="element-120">
        <h2 className="text-4xl font-bold mb-6 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 text-center" data-id="element-121">
          LOOKING FORWARD
        </h2>
        <p className="text-lg text-gray-300 text-center mb-8" data-id="element-122">
          Fabric Reality continues to push boundaries and explore new sonic
          territories. With new music in development and plans for more
          immersive live experiences, the band is dedicated to expanding their
          universe and inviting more listeners to join their cosmic journey.
        </p>
        <div className="flex justify-center" data-id="element-123">
          <Link to="/timeline" className="px-6 py-3 bg-black/50 backdrop-blur-sm border border-pink-500/30 hover:bg-black/70 text-white font-bold rounded-lg transition-all duration-300 flex items-center" data-id="element-124">
            EXPLORE OUR TIMELINE
            <ArrowRightIcon size={18} className="ml-2" data-id="element-125" />
          </Link>
        </div>
      </section>
    </div>;
};
export default Biography;